import ErrorMsgComponent from './errorMsg.component';

export const errorMsgModule = {
	name: 'errorMsgComponent',
};

export default angular
	.module(errorMsgModule.name, [])
	.component('errorMsg', new ErrorMsgComponent()).name;
